module.exports = __webpack_public_path__ + "static/media/meditation.b3453e9f.svg";